module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-over"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v(_vm._s(_vm.$t('User List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('User Over')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.search(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user_list.employee')))])])])])]), (_vm.loading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _vm._e(), (_vm.user != null) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('p', [_c('img', {
    staticClass: "img-rounded",
    staticStyle: {
      "width": "auto",
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.user.attributes['avartar-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    },
    on: {
      "click": function($event) {
        _vm.onClickImageModalShow(_vm.user)
      }
    }
  })]), _c('h4', [_vm._v(_vm._s(_vm.user.attributes['user-name']) + "　" + _vm._s(_vm.user.attributes['user-firstname'])), _c('br'), _vm._v("（" + _vm._s(_vm.user.attributes['user-name-furigana']) + " " + _vm._s(_vm.user.attributes['user-firstname-furigana']) + " ）")]), _c('p', {
    staticClass: "profile"
  }, [_vm._v("性別 : " + _vm._s(_vm.user.attributes['sex'])), _c('br'), _vm._v("生年月日 : " + _vm._s(_vm.user.attributes['user-birthday-format']) + " "), _c('br'), _vm._v("年齢 : " + _vm._s(_vm.user.attributes['age']) + " 歳")])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ＩＤ")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['login-id']))])]), _c('hr'), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("所属店舗")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['shop-name']))])]), _c('hr'), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("役職")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-type-name']))])]), _c('hr'), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("入社日")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-joinday']))])]), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("入社経緯")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['join-class']))])])])])]), _c('hr'), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("離職日")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userover.user_overday),
      expression: "userover.user_overday"
    }],
    class: {
      required: !_vm.validation.user_overday
    },
    attrs: {
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.userover.user_overday)
    },
    on: {
      "input": function($event) {
        _vm.userover.user_overday = $event
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_overday),
      expression: "!validation.user_overday"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validation.user_overday && !_vm.validation.user_overday_range && _vm.errorMsgFlag),
      expression: "validation.user_overday && !validation.user_overday_range && errorMsgFlag"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.date_range')))])], 1)]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("離職区分")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userover.user_turnover_class),
      expression: "userover.user_turnover_class"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_turnover_class
    },
    on: {
      "change": [function($event) {
        _vm.userover.user_turnover_class = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.selectedUserType]
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class1')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class2')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class3')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class4')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class5')))]), _c('option', [_vm._v(_vm._s(_vm.$t('turnover_class.class6')))])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_turnover_class),
      expression: "!validation.user_turnover_class"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("離職事由")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userover.user_turnover_type_id),
      expression: "userover.user_turnover_type_id"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.user_turnover_type_id
    },
    on: {
      "change": function($event) {
        _vm.userover.user_turnover_type_id = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option'), _vm._l((_vm.types), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(type.attributes['turnover-content']))])
  })], 2), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.user_turnover_type_id),
      expression: "!validation.user_turnover_type_id"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("離職事由補記")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userover.user_turnover_remarks),
      expression: "userover.user_turnover_remarks"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "255",
      "rows": "6"
    },
    domProps: {
      "value": _vm._s(_vm.userover.user_turnover_remarks)
    },
    on: {
      "keyup": _vm.strCounter,
      "touchend": _vm.strCounter,
      "change": _vm.strCounter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userover.user_turnover_remarks = $event.target.value
      }
    }
  }), _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.strCount) + "/255")])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-6 text-left"
  }), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onClickSave
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("離職登録")])]), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goBackList
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v("戻る")])])])])]) : _vm._e(), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3e0f4d6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/user-over.pug
// module id = 883
// module chunks = 1